import {Component, Input, OnInit} from '@angular/core';
import {FormArray, FormBuilder, FormGroup, Validators} from '@angular/forms';
import {NgbActiveModal} from '@ng-bootstrap/ng-bootstrap';

@Component({
  selector: 'app-profile-modal-editor',
  templateUrl: './profile-modal-editor.component.html',
  styleUrls: ['./profile-modal-editor.component.scss']
})
export class ProfileModalEditorComponent implements OnInit {
  @Input() list: any[] = [];
  @Input() mantenienceSection: boolean;
  glossary: FormGroup = new FormGroup({
    profiles: new FormArray([])
  });

  constructor(public activeModal: NgbActiveModal, private fb: FormBuilder) {
  }

  ngOnInit(): void {
    this.list.forEach((p) => {
      let {id, list, name, value, viewId} = p;
      let parent: FormGroup = this.fb.group({
        id: [id],
        list: new FormArray([]),
        name: [name],
        value: [value],
        viewId: [viewId]
      });
      list.forEach((i) => {
        const {id, name, value} = i;
        let child: FormGroup = this.fb.group({
          id: [id],
          name: [name],
          value: [value]
        });
        (<FormArray> parent.get('list')).push(child);
      });

      (<FormArray> this.glossary.get('profiles')).push(parent);
    });
  }

  setChildren(index: number, change: boolean) {
    this.glossary.get('profiles')['controls'][index]['controls']['value'].setValidators([Validators.required]);
    const children = this.glossary.get('profiles')['controls'][index]['controls']['list']['controls'];
    children.forEach((f: FormGroup) => {
      f.get('value').setValue(change);
    });
  }

  setParent(index: number) {
    const parent = this.glossary.get('profiles')['controls'][index];
    const children = parent.controls['list'].controls;
    let trueCount = 0;
    children.forEach((v: FormGroup) => {
      if (v.get('value').value === true) {
        trueCount++;
      }
    });
    if (trueCount > 0) {
      parent.get('value').setValue(true);
    } else {
      parent.get('value').setValue(false);
    }
  }

  send(): void {
    this.activeModal.close([...this.glossary.get('profiles').value]);
  }
}
